import { BaseModel } from 'src/app/@shared/base.model';
import { Role, RoleName } from '@common/entities';

export type RoleSource = Role;

export class RoleModel extends BaseModel<RoleSource> {
  public description: string;
  public slug: RoleName;
  public displayName: string;

  constructor(source: RoleSource) {
    super(source);

    this.description = source.description;
    this.slug = source.slug;
    this.displayName = source.title || source.slug;
  }
}

export function mapRoleModelToSource(role: RoleModel): RoleSource {
  return {
    createdAt: role.createdAt,
    description: role.description,
    id: role.id,
    slug: role.slug,
    title: role.title,
    toJson: (): any => {
      return {
        createdAt: role.createdAt,
        description: role.description,
        id: role.id,
        slug: role.slug,
        title: role.title,
        updatedAt: role.updatedAt,
      };
    },
    updatedAt: role.updatedAt,
  };
}
